import { APIS, TENANT_ID } from '../../../../utils/api-factory'
import { POST_HEADER, TENANT_HEADER, TENANT_POST_HEADER, TENANT_BRE_POST_HEADER } from '../../../../utils/apiHeaders'
import axios from 'axios';



export const getNBFCList = (callBack,error) =>{
    axios.get(APIS.GET_LIST_OF_NBFC)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}


export const getMonthWiseCustomerAcquisitonCostByDateAPI = (sDate,eDate,nbfcId,productId,callBack,error) =>{
    axios.get(APIS.GET_MONTHS_WISE_CUSTOMER_ACQUISITION_COST_BY_DATE + sDate + "&endDate=" + eDate  +"&nbfcId=" + nbfcId + "&productId=" + productId,TENANT_HEADER)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const getMonthWiseRecievedAmountByDateAPI = (sDate,eDate,nbfcId,productId,callBack,error) =>{
    axios.get(APIS.GET_MONTHS_WISE_RECIEVED_AMOUNT_BY_DATE + sDate + "&endDate=" + eDate  +"&nbfcId=" + nbfcId + "&productId=" + productId,TENANT_HEADER)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const getMonthWiseIncomeRecievedAmountByDateAPI = (sDate,eDate,nbfcId,productId,callBack,error) =>{
    axios.get(APIS.GET_MONTHS_WISE_INCOME_AMOUNT_BY_DATE + sDate + "&endDate=" + eDate  +"&nbfcId=" + nbfcId + "&productId=" + productId,TENANT_HEADER)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const getMonthWiseAccuralAmountByDateAPI = (sDate,eDate,nbfcId,productId,callBack,error) =>{
    axios.get(APIS.GET_MONTHS_WISE_ACCURAL_AMOUNT_BY_DATE + sDate + "&endDate=" + eDate  +"&nbfcId=" + nbfcId + "&productId=" + productId,TENANT_HEADER)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}

export const    SaveLockcacMonthData = (data,callBack,error) =>{
    const headerConfig = {
        headers:TENANT_POST_HEADER
    }
    axios.post(APIS.SAVE_OR_LOCK_CAC_MONTH_DATA ,data,headerConfig)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const    SaveLockINCOMEMonthData = (data,callBack,error) =>{
    const headerConfig = {
        headers:TENANT_POST_HEADER
    }
    axios.post(APIS.SAVE_OR_LOCK_CINCOME_EFFICIENCY_MONTH_DATA ,data,headerConfig)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}

export const UnlockcacMonthData = (data,callBack,error) =>{
    const headerConfig = {
        headers:TENANT_POST_HEADER
    }
    axios.post(APIS.UNLOCK_CAC_MONTH_DATA ,data,headerConfig)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const UnlockIncomeMonthData = (data,callBack,error) =>{
    const headerConfig = {
        headers:TENANT_POST_HEADER
    }
    axios.post(APIS.UNLOCK_INCOME_MONTH_DATA ,data,headerConfig)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const UnlockTicketSizeMonthData = (data,callBack,error) =>{
    const headerConfig = {
        headers:TENANT_POST_HEADER
    }
    axios.post(APIS.UNLOCK_TICKET_SIZE_MONTH_DATA ,data,headerConfig)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const UnlockLoanApplicationMonthData = (data,callBack,error) =>{
    const headerConfig = {
        headers:TENANT_POST_HEADER
    }
    axios.post(APIS.UNLOCK_MONTH_WISE_LOAN_MONTH_DATA ,data,headerConfig)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const UnlockcollectionEfficeiencyMonthData = (data,callBack,error) =>{
    const headerConfig = {
        headers:TENANT_POST_HEADER
    }
    axios.post(APIS.UNLOCK_COLLECTION_EFFCIENCY_LOAN_MONTH_DATA ,data,headerConfig)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}

export const getMonthWiseCollectionEfficiencyByDateAPI = (sDate,eDate,nbfcId,productId,callBack,error) =>{
    axios.get(APIS.GET_MONTHS_WISE_COLLECTION_EFFICIENCY_BY_DATE + sDate + "&endDate=" + eDate  +"&nbfcId=" + nbfcId + "&productId=" + productId,TENANT_HEADER)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const SaveLockcollectionEfficiencyMonthData = (data,callBack,error) =>{
    const headerConfig = {
        headers:TENANT_POST_HEADER
    }
    axios.post(APIS.SAVE_OR_LOCK_COLLECTION_EFFICIENCY_MONTH_DATA ,data,headerConfig)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const getMonthWiseTicketSizeByDateAPI = (sDate,eDate,nbfcId,productId,callBack,error) =>{
    axios.get(APIS.GET_MONTHS_WISE_TICKET_SIZE_BY_DATE + sDate + "&endDate=" + eDate  +"&nbfcId=" + nbfcId + "&productId=" + productId,TENANT_HEADER)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const SaveLockTicketSizeMonthData = (data,callBack,error) =>{
    const headerConfig = {
        headers:TENANT_POST_HEADER
    }
    axios.post(APIS.SAVE_OR_LOCK_TICKET_SIZE_MONTH_DATA ,data,headerConfig)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const getMonthWiseLoanApplicationByDateAPI = (sDate,eDate,nbfcId,productId,callBack,error) =>{
    axios.get(APIS.GET_MONTHS_WISE_LOAN_APPLICATION_BY_DATE + sDate + "&endDate=" + eDate  +"&nbfcId=" + nbfcId + "&productId=" + productId,TENANT_HEADER)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const SaveLockLoanApplicationMonthData = (data,callBack,error) =>{
    const headerConfig = {
        headers:TENANT_POST_HEADER
    }
    axios.post(APIS.SAVE_OR_LOCK_LOAN_APPLICATION_MONTH_DATA ,data,headerConfig)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const downlaodMsiDataList = (start,endDate,nbfc,productId,type,callBack,error) =>{
   const headerConfig = {
        headers:TENANT_POST_HEADER
    }
    axios.get(APIS.DOWNLOAD_LIST_DATA_MIS + start + "&endDate=" + endDate + "&nbfcId=" + nbfc + "&productId=" + productId + "&type=" + type,headerConfig)
     .then((response) => {
      const blob = new Blob([response.data], {
        type: "text/csv;charset=utf-8;",
      });

      const downloadUrl = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `MIS_${new Date().toISOString().split("T")[0]}.csv`;

      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(downloadUrl);

      callBack && callBack(response.data);
    })
    .catch((err) => {
      console.error(err);
      error && error(err);
    });
}